var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100",class:[_vm.skinClasses, _vm.appClass ],attrs:{"id":"app"}},[_c(_vm.layout,{tag:"component",staticClass:"main-layout",style:({paddingTop: (_vm.offset + "px") })},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }